const resource = {
    resource_identifier_in_use: 'API 标识符 {{indicator}} 已被使用',
};
export default resource;
